import { defineStore } from "pinia";
import { useWorkflowStepStore } from "@/stores/workflowStepStore";
import { pushOrSet } from "@/utils/pushOrSet";
import Vue from "vue";
export const useConnectionStore = defineStore("workflowConnectionStore", {
    state: () => ({
        connections: [],
        invalidConnections: {},
        inputTerminalToOutputTerminals: {},
        terminalToConnection: {},
        stepToConnections: {},
    }),
    getters: {
        getOutputTerminalsForInputTerminal(state) {
            return (terminalId) => {
                return state.inputTerminalToOutputTerminals[terminalId] || [];
            };
        },
        getConnectionsForTerminal(state) {
            return (terminalId) => {
                return state.terminalToConnection[terminalId] || [];
            };
        },
        getConnectionsForStep(state) {
            return (stepId) => state.stepToConnections[stepId] || [];
        },
    },
    actions: {
        addConnection(_connection) {
            const connection = Object.freeze(_connection);
            this.connections.push(connection);
            const stepStore = useWorkflowStepStore();
            stepStore.addConnection(connection);
            this.terminalToConnection = updateTerminalToConnection(this.connections);
            this.inputTerminalToOutputTerminals = updateTerminalToTerminal(this.connections);
            this.stepToConnections = updateStepToConnections(this.connections);
        },
        markInvalidConnection(connectionId, reason) {
            Vue.set(this.invalidConnections, connectionId, reason);
        },
        dropFromInvalidConnections(connectionId) {
            Vue.delete(this.invalidConnections, connectionId);
        },
        removeConnection(terminal) {
            const stepStore = useWorkflowStepStore();
            this.connections = this.connections.filter((connection) => {
                const id = getConnectionId(connection);
                if (typeof terminal === "string") {
                    if (id === terminal) {
                        stepStore.removeConnection(connection);
                        Vue.delete(this.invalidConnections, id);
                        return false;
                    }
                    else {
                        return true;
                    }
                }
                else if (terminal.connectorType === "input") {
                    if (connection.input.stepId == terminal.stepId && connection.input.name == terminal.name) {
                        stepStore.removeConnection(connection);
                        Vue.delete(this.invalidConnections, id);
                        return false;
                    }
                    else {
                        return true;
                    }
                }
                else {
                    if (connection.output.stepId == terminal.stepId && connection.output.name == terminal.name) {
                        stepStore.removeConnection(connection);
                        Vue.delete(this.invalidConnections, id);
                        return false;
                    }
                    else {
                        return true;
                    }
                }
            });
            this.terminalToConnection = updateTerminalToConnection(this.connections);
            this.inputTerminalToOutputTerminals = updateTerminalToTerminal(this.connections);
            this.stepToConnections = updateStepToConnections(this.connections);
        },
    },
});
function updateTerminalToTerminal(connections) {
    const inputTerminalToOutputTerminals = {};
    connections.forEach((connection) => {
        const terminals = getTerminals(connection);
        const inputTerminalId = getTerminalId(terminals.input);
        pushOrSet(inputTerminalToOutputTerminals, inputTerminalId, terminals.output);
    });
    return inputTerminalToOutputTerminals;
}
function updateTerminalToConnection(connections) {
    const terminalToConnection = {};
    connections.forEach((connection) => {
        const terminals = getTerminals(connection);
        const outputTerminalId = getTerminalId(terminals.output);
        pushOrSet(terminalToConnection, outputTerminalId, connection);
        const inputTerminalId = getTerminalId(terminals.input);
        pushOrSet(terminalToConnection, inputTerminalId, connection);
    });
    return terminalToConnection;
}
function updateStepToConnections(connections) {
    const stepToConnections = {};
    connections.forEach((connection) => {
        pushOrSet(stepToConnections, connection.input.stepId, connection);
        pushOrSet(stepToConnections, connection.output.stepId, connection);
    });
    return stepToConnections;
}
export function getTerminalId(item) {
    return `node-${item.stepId}-${item.connectorType}-${item.name}`;
}
export function getTerminals(item) {
    return {
        input: { stepId: item.input.stepId, name: item.input.name, connectorType: "input" },
        output: { stepId: item.output.stepId, name: item.output.name, connectorType: "output" },
    };
}
export function getConnectionId(item) {
    return `${item.input.stepId}-${item.input.name}-${item.output.stepId}-${item.output.name}`;
}
